<template>
  <div class="row">
    <!-- <div class="col-md-8"></div> -->
    <AnnouncementPortlet />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import AnnouncementPortlet from "@/components/announcements/AnnouncementPortlet";

export default {
  name: "TheDashboard",
  components: { AnnouncementPortlet },
  data() {
    return {};
  },
  computed: {
    ...mapGetters("user", ["isNotSubcontractor"])
  },
  methods: {
    showModal(announcment_id) {
      if (announcment_id) {
        this.selected = this.$_.find(this.items, { id: announcment_id });
      }
      this.$nextTick(() => {
        this.$bvModal.show("anouncment-modal");
      });
    }
  }
};
</script>